import React from "react"
import styled from "styled-components"

const ProductsGrid = ({children}: {children: React.ReactNode}) => {
  return (
    <OuterContainer>
      <StoreGrid>
        <GridContainer>{children}</GridContainer>
      </StoreGrid>
    </OuterContainer>
  )
}

export default ProductsGrid

const OuterContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`

const StoreGrid = styled.div`
  flex-grow: 1;
  position: relative;
  min-height: 100vh;
  margin: 0 0 24px 0;

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    margin: 24px;
  `}
`

const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 48px 8px 0 8px;
  column-gap: 16px;
  row-gap: 32px;
  justify-content: center;
`
